import {
  Component,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { LayoutService } from '../services';

@Component({
  selector: 'lib-navigation',
  template: `
    <ul class="navbar-nav float-left mr-auto">
      <li class="nav-item d-none d-md-block" *ngIf="false">
        <a
          (click)="toggleSidebar.emit()"
          class="nav-link sidebartoggler waves-effect waves-light"
          href="javascript:void(0)"
        >
          <i class="ti ti-menu"></i>
        </a>
      </li>
    </ul>
    <ul class="navbar-nav float-right">
      <ng-content></ng-content>
    </ul>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
  @Output() toggleSidebar = new EventEmitter<void>();

  constructor(private layoutSvc: LayoutService) {}
}
